import React, { Component } from 'react'
import { connect } from "react-redux";
import { Button } from 'reactstrap';
import { Helmet } from 'react-helmet-async';
import IconButton from '@mui/material/IconButton';
import MUIDataTable from "mui-datatables";
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';

import moment from 'moment';

import { NotificationManager } from 'react-notifications';

// intl messages
import IntlMessages from 'Util/IntlMessages';
// page title bar
import PageTitleBar from 'Components/PageTitleBar/PageTitleBar';
// app config
import AppConfig from 'Constants/AppConfig';

import AddSCElement from './component/addstc';
import EditSCElement from './component/editstc';
import ConfirmationDialog from "Routes/common/ConfirmationDialog";


import {
   allSCAssessment,
   allStudents,
   fetchSCAssessment,
   deleteSCAssessment
} from 'Actions';

// rct card box
import RctCollapsibleCard from 'Components/RctCollapsibleCard/RctCollapsibleCard';

class strengthcondition extends Component {

   constructor(props) {

      super(props);
      this.confirmationDialog = React.createRef();
      this.state = {
         student: '',
         quarter: '',
         seldate: '',
         actionvalue: '',
         viewdiv: true,
         adddiv: false,
         addinnerdiv: true,
         editdiv: false,
         scheight: '',
         scwaist: '',
         scweight: '',
         scbmi: '',
         schip: '',
         scwhratio: '',
         rmtest: false,
         aerobictest: false,
         lowerbodytest: false,
         upperbody: false,
         acceleration: false,
         coreendurance: false,
         deepsquat_finalscore: 0,
         hurdlestep_r_finalscore: 0,
         inlinelunge_r_finalscore: 0,
         shouldermobility_r_finalscore: 0,
         activestraightlegraise_r_finalscore: 0,
         trunkstabilitypushup_finalscore: 0,
         rotarystability_r_finalscore: 0,
         fmtotalscore: 0,
         aerobicfitness_time: 0,
         aerobicfitness_vo: 0,
         rmcleanestimate_rm: '',
         rmcleanestimate_value: "",
         rmclean_value: 0,
         rmsquat_rm: '',
         rmsquatestimate_value: "",
         rmsquat_value: 0,
         rmpress_rm: '',
         rmpressestimate_value: "",
         rmpress_value: 0,

         deepsquat_rawscore: 0,
         hurdlestep_r_rawscore: 0,
         hurdlestep_l_rawscore: 0,
         inlinelunge_r_rawscore: 0,
         inlinelunge_l_rawscore: 0,
         shouldermobility_r_rawscore: 0,
         shouldermobility_l_rawscore: 0,
         activestraightlegraise_r_rawscore: 0,
         activestraightlegraise_l_rawscore: 0,
         rotarystability_r_rawscore: 0,
         rotarystability_l_rawscore: 0,
         trunkstabilitypushup_rawscore: 0,

         boxjump_score: '',
         singlerighthopright_score: '',
         singlerighthopleft_score: '',
         deadlift_score: '',
         pullup_score: '',
         pushup_score: '',
         plank_score: '',
         medicineball_score: '',

         lowerboay_trial1: '',
         lowerboay_trial2: '',
         lowerboay_trial3: '',
         lowerboay_result: '',
         acceleration_trial1: '',
         acceleration_trial2: '',
         acceleration_trial3: '',
         acceleration_result: '',
      };


      this.onBackSection = this.onBackSection.bind(this);
      this.editAssessment = this.editAssessment.bind(this);
      this.deleteAssessment = this.deleteAssessment.bind(this);
   }

   UNSAFE_componentWillMount() {
      this.props.allSCAssessment();
   }

   onBackSection() {
      this.setState({
         adddiv: false,
         editdiv: false,
         viewdiv: true
      });
   }

   onAddSession() {
      this.setState({
         viewdiv: false,
         editdiv: false,
         adddiv: true
      });
   }



   editAssessment(rowdata) {

      this.props.fetchSCAssessment(rowdata).then((data) => {
         var resdata = data.data;
         if (resdata[0].onermtestcheck == 1) {
            var rmtest = true;
         } else {
            var rmtest = false;
         }

         if (resdata[0].aerobicfitnesscheck == 1) {
            var aerobictest = true;
         } else {
            var aerobictest = false;
         }

         if (resdata[0].lowerbodypowercheck == 1) {
            var lowerbodytest = true;
         } else {
            var lowerbodytest = false;
         }

         if (resdata[0].upperbodystrengthcheck == 1) {
            var upperbody = true;
         } else {
            var upperbody = false;
         }

         if (resdata[0].accelerationspeedcheck == 1) {
            var acceleration = true;
         } else {
            var acceleration = false;
         }

         if (resdata[0].coreendurancecheck == 1) {
            var coreendurance = true;
         } else {
            var coreendurance = false;
         }

         var scbmival = resdata[0].scbmi;
         var whratioval = resdata[0].scwhratio;
         var gender = resdata[0].uud_gender;

         if (scbmival == 0) {
            var colorcode = '#F4F7FA';
         } else if (scbmival <= '17.9') {
            var colorcode = '#e6cc00';
         } else if (scbmival >= '18.0' && scbmival <= '24.9') {
            var colorcode = '#00c04b';
         } else if (scbmival >= '25.0' && scbmival <= '29.9') {
            var colorcode = '#F27F0C';
         } else if (scbmival >= '30') {
            var colorcode = '#de0a26';
         }

         if (gender == 1) {
            if (whratioval == 0) {
               var wabcolcode = '#F4F7FA';
            } else if (whratioval <= '0.95') {
               var wabcolcode = '#4DED30';
            } else if (whratioval >= '0.96' && whratioval <= '1.0') {
               var wabcolcode = '#F27F0C';
            } else if (whratioval >= '1.1') {
               var wabcolcode = '#de0a26';
            }
         } else {
            if (whratioval == 0) {
               var wabcolcode = '#F4F7FA';
            } else if (whratioval <= '0.80') {
               var wabcolcode = '#4DED30';
            } else if (whratioval >= '0.81' && whratioval <= '0.84') {
               var wabcolcode = '#F27F0C';
            } else if (whratioval >= '0.85') {
               var wabcolcode = '#de0a26';
            }
         }



         this.setState({


            scheight: resdata[0].scheight,
            scweight: resdata[0].scweight,
            scbmi: scbmival,
            scwaist: resdata[0].scwaist,
            schip: resdata[0].schip,
            scwhratio: whratioval,
            bgColor: colorcode,
            wabgColor: wabcolcode,
            gender: gender,

            deepsquat_finalscore: resdata[0].deepsquat_finalscore,
            hurdlestep_r_finalscore: resdata[0].hurdlestep_r_finalscore,
            inlinelunge_r_finalscore: resdata[0].inlinelunge_r_finalscore,
            shouldermobility_r_finalscore: resdata[0].shouldermobility_r_finalscore,
            activestraightlegraise_r_finalscore: resdata[0].activestraightlegraise_r_finalscore,
            trunkstabilitypushup_finalscore: resdata[0].trunkstabilitypushup_finalscore,
            rotarystability_r_finalscore: resdata[0].rotarystability_r_finalscore,
            fmtotalscore: resdata[0].totalscore_finalscore,

            aerobicfitness_time: resdata[0].aerobicfitness_time,
            aerobicfitness_vo: resdata[0].aerobicfitness_vo,

            rmcleanestimate_rm: resdata[0].rmcleanestimate_rm,
            rmcleanestimate_value: resdata[0].rmcleanestimate_value,
            rmclean_value: resdata[0].rmclean_value,
            rmsquat_rm: resdata[0].rmsquatestimate_rm,
            rmsquatestimate_value: resdata[0].rmsquatestimate_value,
            rmsquat_value: resdata[0].rmsquat_value,
            rmpress_rm: resdata[0].rmpressestimate_rm,
            rmpressestimate_value: resdata[0].rmpressestimate_value,
            rmpress_value: resdata[0].rmpress_value,

            deepsquat_rawscore: resdata[0].deepsquat_rawscore,
            hurdlestep_r_rawscore: resdata[0].hurdlestep_r_rawscore,
            hurdlestep_l_rawscore: resdata[0].hurdlestep_l_rawscore,
            inlinelunge_r_rawscore: resdata[0].inlinelunge_r_rawscore,
            inlinelunge_l_rawscore: resdata[0].inlinelunge_l_rawscore,
            shouldermobility_r_rawscore: resdata[0].shouldermobility_r_rawscore,
            shouldermobility_l_rawscore: resdata[0].shouldermobility_l_rawscore,
            activestraightlegraise_r_rawscore: resdata[0].activestraightlegraise_r_rawscore,
            activestraightlegraise_l_rawscore: resdata[0].activestraightlegraise_l_rawscore,
            rotarystability_r_rawscore: resdata[0].rotarystability_r_rawscore,
            rotarystability_l_rawscore: resdata[0].rotarystability_l_rawscore,
            trunkstabilitypushup_rawscore: resdata[0].trunkstabilitypushup_rawscore,

            boxjump_score: resdata[0].boxjump_score,
            singlerighthopright_score: resdata[0].singlerighthopright_score,
            singlerighthopleft_score: resdata[0].singlerighthopleft_score,
            deadlift_score: resdata[0].deadlift_score,
            pullup_score: resdata[0].pullup_score,
            pushup_score: resdata[0].pushup_score,
            plank_score: resdata[0].plank_score,
            medicineball_score: resdata[0].medicineball_score,

            rmtest: rmtest,
            aerobictest: aerobictest,
            lowerbodytest: lowerbodytest,
            upperbody: upperbody,
            acceleration: acceleration,
            coreendurance: coreendurance,

            lowerboay_trial1: resdata[0].lowerboay_trial1,
            lowerboay_trial2: resdata[0].lowerboay_trial2,
            lowerboay_trial3: resdata[0].lowerboay_trial3,
            lowerboay_result: resdata[0].lowerboay_result,
            acceleration_trial1: resdata[0].acceleration_trial1,
            acceleration_trial2: resdata[0].acceleration_trial2,
            acceleration_trial3: resdata[0].acceleration_trial3,
            acceleration_result: resdata[0].acceleration_result,

            viewdiv: false,
            adddiv: false,
            editdiv: true
         });
      });

   }

   deleteAssessment(scid) {
      this.id = scid;
      this.confirmationDialog.current.openDialog();
   }

   deleteDataPermanent(popupResponse) {

      if (popupResponse) {
         this.props.deleteSCAssessment(this.id);
         this.data = ""
      }
   }

   render() {
      const { match, strengthconditionlists, studentlists, loading } = this.props;

      const allstudent = studentlists.map((stdval) => {
         return {
            label: stdval.student,
            value: stdval.uudID
         }
      });

      const options = {
         filterType: 'dropdown',
         rowsPerPage: 50,
         rowsPerPageOptions: [50, 100, 150],
         selectableRowsHideCheckboxes: true,
      };
      const columns = [
         { name: "no", label: "No" },
         { name: "name", label: "Name" },
         { name: "assessment", label: "Assessment No" },
         { name: "date", label: "Date" },
         { name: "edit", label: "Edit" },
         { name: "delete", label: "Delete" }
      ];
      const tabledata = strengthconditionlists.map((assmntval, idx) => {

         const ebtn = <IconButton className='text-info' onClick={() => this.editAssessment(assmntval)}><EditOutlinedIcon/></IconButton>;
         const dbtn = <IconButton className="text-danger" aria-label="Delete" onClick={() => this.deleteAssessment(assmntval.scID)}><DeleteOutlineOutlinedIcon/></IconButton>;

         return {
            no: idx + 1,
            name: assmntval.student,
            assessment: assmntval.quarter,
            date: assmntval.cdate,
            edit: ebtn,
            delete: dbtn
         }
      });
      return (
         <div className="saas-dashboard">
            <Helmet>
               <title>Strength And Condition | {AppConfig.appTitle}</title>
               <meta name="description" content="Reactify Sass Dashboard" />
            </Helmet>
            <PageTitleBar title={<IntlMessages id="sidebar.strengthconditionheading" />} match={match} />
            <div className="row">
               {this.state.viewdiv &&
                  <div className="col-sm-12 col-md-8">
                     <RctCollapsibleCard heading="List" fullBlock>
                        <MUIDataTable
                           title={<div><Button onClick={() => this.onAddSession()} className="btn btn-outline-info"><i className="zmdi zmdi-plus-circle-o"></i>  Create Assessment</Button></div>}
                           data={tabledata}
                           columns={columns}
                           options={options}
                        />
                     </RctCollapsibleCard>
                  </div>
               }
            </div>
            {this.state.adddiv &&
               <AddSCElement onClick={this.onBackSection} />
            }

            {this.state.editdiv &&
               <EditSCElement onClick={this.onBackSection} data={this.state} />
            }

            <ConfirmationDialog
               ref={this.confirmationDialog}
               onConfirm={(res) => this.deleteDataPermanent(res)}
               data={'Record'}
            />

         </div>
      )
   }
}


const mapStateToProps = ({ scassessment, mostlyused }) => {
   const { strengthconditionlists, loading } = scassessment;
   const { studentlists } = mostlyused;
   return { strengthconditionlists, studentlists, loading };

}

export default connect(mapStateToProps, {
   allSCAssessment,
   allStudents,
   fetchSCAssessment,
   deleteSCAssessment
})(strengthcondition); 